import { InputLabel } from '@material-ui/core';
import { Button } from '@vadiun/react-components';
import { ViajeCanalesDeIngreso } from 'app/viaje/models';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';

type Props = {
  onSubmit(value: { observation: string }): Promise<void>;
  reservation: any;
};

export const ViajeAValidarDenyForm = ({ onSubmit, reservation }: Props) => {
  return (
    <Formik
      initialValues={{ observation: '', cancellationReasonClient: "" }}
      validationSchema={Yup.object({
        observation: Yup.string().required('ingrese una observación'),
        cancellationReasonClient: Yup.string()
          .test(
            'is-required-for-app',
            'Ingrese un mensaje',
            function(value) {
              if (reservation?.entryChannel === ViajeCanalesDeIngreso.APP) {
                return !!value;
              }
              return true; 
            }
          )
      })}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Form className="p-8">
           <div className='flex flex-col gap-10'>
          <div className='flex flex-col gap-2'>
            <InputLabel>Observación</InputLabel>
            <Field
              name="observation"
              component={TextField}
              fullWidth
              placeholder="Ingrese la observación"
            />
           </div>
          { reservation?.entryChannel ===  ViajeCanalesDeIngreso.APP &&    
          <div className='flex flex-col gap-2'>
            <InputLabel>Mensaje para el usuario de la app</InputLabel>
              <Field
                  name="cancellationReasonClient"
                  component={TextField}
                  fullWidth
                  placeholder="Ingrese el mensaje"
              />
          </div>}
          </div>
          <div className="flex justify-end mt-8">
            <Button
              type="submit"
              disabled={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              variant="contained"
            >
              Continuar
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};
